import React from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";
import { validateHex } from "../utils/branding";

interface ColorFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const ColorField: React.FC<ColorFieldProps> = ({
  label,
  value,
  onChange,
  error,
}) => (
  <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        component="input"
        type="color"
        value={validateHex(value) && value.trim().length > 0 ? value : "#000000"}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        sx={{
          width: 40,
          height: 40,
          padding: 0,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          background: "transparent",
          cursor: "pointer",
        }}
      />
      <TextField
        fullWidth
        size="small"
        placeholder="#ffffff"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        error={!!error}
        helperText={error || "Leave blank to use default."}
      />
    </Stack>
  </Stack>
);
